// UPDATE FOOTABLL TEAM SYNOPSIS
// node: domnode, team: object
export default function(node, team) {
  if (!node) {
    return;
  }

  let html = '';
  let template;

  if (team.synopsis) {
    template = node.getAttribute('data-update-template-event');

    team.synopsis.split('~').forEach(line => {
      // add tick to numbers, eg 56 becomes 56'
      let eachLine = line.replace(/([0-9]{1,3})/g, match => {
        return `${match}'`;
      });

      eachLine = eachLine.replace(/([0-9]{1,3})/, match => {
        return `(${match}`;
      });

      eachLine = eachLine.replace(/'\+/g, '+');

      // add sending off icon
      eachLine = eachLine.replace('s/o', node.getAttribute('data-update-template-sent-off'));

      // add 'og' translation
      eachLine = eachLine.replace(/\bog\b/gi, node.getAttribute('data-update-template-own-goal'));

      // add penalty translation
      eachLine = eachLine.replace(/\bpen\b/gi, `${node.getAttribute('data-penalty')}`);

      html += template.replace(/#{player}/, `${eachLine})`);
    });
  }

  node.innerHTML = html;
}

// // UPDATE FOOTABLL TEAM SYNOPSIS
// // node: domnode, team: object
// export default function (node, team) {
//   if (!node) {
//     return;
//   }

//   let html = '';
//   let template;

//   if (team.synopsis) {
//     template = node.getAttribute('data-update-template-event');

//     team.synopsis.split('~').forEach(line => {
//       // add tick to numbers, eg 56 becomes 56'
//       let eachLine = line.replace(/([0-9]{1,3})/g, match => {
//         return `${match}'`;
//       });

//       eachLine = eachLine.replace(/'\+/g, '+');

//       // add sending off icon
//       eachLine = eachLine.replace('s/o', node.getAttribute('data-update-template-sent-off'));

//       // add 'og' translation
//       eachLine = eachLine.replace(/\bog\b/gi, `(${node.getAttribute('data-owngoal')})`);

//       // add penalty translation
//       eachLine = eachLine.replace(/\bpen\b/gi, `(${node.getAttribute('data-penalty')})`);

//       html += template.replace(/#{player}/, eachLine);
//     });
//   }

//   node.innerHTML = html;
// }
